// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__380es","newExpiryDate":"styles_newExpiryDate__rUVvU","footer":"styles_footer__3GRRC"};